import React from "react";
import "./RemovePlayerDialog.css";

interface RemovePlayerDialogProps {
  playerName: string;
  onKick: () => void;
  onBan: () => void;
  onCancel: () => void;
}

export const RemovePlayerDialog: React.FC<RemovePlayerDialogProps> = ({
  playerName,
  onKick,
  onBan,
  onCancel,
}) => {
  const handleOverlayClick = () => {
    onCancel();
  };

  return (
    <div className="remove-player-dialog">
      <div
        className="remove-player-dialog__overlay"
        onClick={handleOverlayClick}
      />
      <div className="remove-player-dialog__modal">
        <button
          className="remove-player-dialog__close"
          onClick={onCancel}
          type="button"
        >
          ×
        </button>
        <h2 className="remove-player-dialog__title">Spieler entfernen</h2>
        <p className="remove-player-dialog__description">
          Wie möchtest du <strong>{playerName}</strong> entfernen?
        </p>
        <div className="remove-player-dialog__buttons">
          <button
            className="remove-player-dialog__btn remove-player-dialog__btn--kick"
            onClick={onKick}
            type="button"
          >
            <span className="remove-player-dialog__btn-icon">🦶</span>
            <div className="remove-player-dialog__btn-content">
              <div className="remove-player-dialog__btn-title">Kicken</div>
              <div className="remove-player-dialog__btn-desc">
                Kann wieder joinen
              </div>
            </div>
          </button>
          <button
            className="remove-player-dialog__btn remove-player-dialog__btn--ban"
            onClick={onBan}
            type="button"
          >
            <span className="remove-player-dialog__btn-icon">🚫</span>
            <div className="remove-player-dialog__btn-content">
              <div className="remove-player-dialog__btn-title">Bannen</div>
              <div className="remove-player-dialog__btn-desc">
                Dauerhaft sperren
              </div>
            </div>
          </button>
        </div>
        <button
          className="remove-player-dialog__cancel"
          onClick={onCancel}
          type="button"
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
};
